export default __webpack_public_path__ + "static/media/8t.1deb9203.jpg";